export default __webpack_public_path__ + "static/media/SaritaSundar.44717507.png";